import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { Card, Title } from '@tremor/react';
import SelectReportType from './steps/SelectReportType';
import SelectReportFilters from './steps/SelectReportFilters';
import GenerateReportData from './steps/GenerateReportData';
import WizardFooter from './steps/WizardFooter';
 

import {
    showLoading,
    fetchPropertiesUnitsTenants,
    fetchOptions,
    downloadTenantTransactionsReport,
    generateReports,
    generateMultiPropertyReports,
    generateArrearsReports,
    generateExpensesReports,
    generateMonthOnMonthReports,
    generateYearOnYearReports,
    generatePropertyGroupingReport,
    generateDeletedTenantsReport,
    fetchPropertyTenants
} from '../../redux/actions';

 

 

const TENANT_STATMENT = "Tenant Statement";
const PROPERTY_STATEMENT = "Property Statement";
const ARREARS_REPORT = "Arrears Report";
const EXPENSES_REPORT = "Expenses Report";
const MONTH_ON_MONTH_REPORT = "Month on Month Report";
const YEAR_ON_YEAR_REPORT = "Year on Year Report";
const PROPERTY_GROUPING_REPORT = "Property Grouping Report";
const DELETED_TENANTS_REPORT = "Deleted Tenants Report";

const STATEMENT_TYPES = [
  TENANT_STATMENT,
  PROPERTY_STATEMENT,
  ARREARS_REPORT,
  EXPENSES_REPORT,
  MONTH_ON_MONTH_REPORT,
  YEAR_ON_YEAR_REPORT,
  DELETED_TENANTS_REPORT,
  // PROPERTY_GROUPING_REPORT
];

const mapStateToProps = state => ({
    properties: state.properties,
    tenants: state.tenants,
    options: state.options,
});

const mapDispatchToProps = {
    showLoading,
    fetchPropertiesUnitsTenants,
    fetchOptions,
    downloadTenantTransactionsReport,
    generateReports,
    generateMultiPropertyReports,
    generateArrearsReports,
    generateExpensesReports,
    generateMonthOnMonthReports,
    generateYearOnYearReports,
    generatePropertyGroupingReport,
    generateDeletedTenantsReport,
    fetchPropertyTenants
};

class Reports extends React.Component{
    constructor(props){
        super(props);
        const today = new Date();
        const end_date_default = today.toISOString().slice(0,10);
        const end_mom_default = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
        const end_yoy_default = String(today.getFullYear());
        this.state = {
            statementType: TENANT_STATMENT,
            propertyId: "",
            propertyIds: [],
            tenant: [],
            startDate: null,
            endDate: end_date_default,
            startMoMDate: null,
            endMoMDate: end_mom_default,
            startYearOnYearDate: null,
            endYearOnYearDate: end_yoy_default,
            selectedColumns: [],
            showArchivedTenants: true,
            showNonPropertyExpenses: false,
            selectedGroupingGraphColumns: [],
            groupingIds: [],
            tableData: [],
            columns: [],
            propertyTables: null,
            multiPropertyData: null,
            currentStep: 1,
            tenantOptions: [],
            groupingsOptions: [],
            validationError: '',
            filterErrors: [],
            columnsModalOpen: false,
            tmpSelectedColumns: [],
            loadingTenants: false,
            expandedCards: {},
            collapseDate: true,
            collapseMoM: true,
            collapseYoY: true,
        };
    }

    async componentDidMount(){
        if (!this.props.properties || Object.keys(this.props.properties).length === 0){
            this.props.showLoading(true);
            await this.props.fetchPropertiesUnitsTenants();
        }
        if (!this.props.options || Object.keys(this.props.options).length === 0){
            this.props.showLoading(true);
            await this.props.fetchOptions();
        }
        if (Object.values(this.props.properties).length === 1) {
            this.setState({ propertyId: Object.values(this.props.properties)[0].propertyId })
        }
        this.props.showLoading(false);
    }

    validateInputs = () => {
        const { statementType, tenant, propertyId, startDate, endDate, startMoMDate, endMoMDate, startYearOnYearDate, endYearOnYearDate } = this.state;
        if (statementType === TENANT_STATMENT) {
            if (!tenant?.[0]?.id) return 'Please select a tenant.';
        } else if (statementType === DELETED_TENANTS_REPORT) {
            if (!propertyId) return 'Please select a property.';
        } else if (statementType === PROPERTY_STATEMENT) {
            if (!this.state.propertyIds || this.state.propertyIds.length === 0) return 'Please select at least one property.';
            if (!startDate || !endDate) return 'Please select start and end dates.';
            if (startDate && endDate && new Date(startDate) > new Date(endDate)) return 'End Date must be on/after Start Date.';
        } else if (statementType === ARREARS_REPORT || statementType === EXPENSES_REPORT) {
            if (!propertyId) return 'Please select a property.';
            if (!startDate || !endDate) return 'Please select start and end dates.';
            if (startDate && endDate && new Date(startDate) > new Date(endDate)) return 'End Date must be on/after Start Date.';
        } else if (statementType === MONTH_ON_MONTH_REPORT) {
            if (!propertyId) return 'Please select a property.';
            if (!startMoMDate || !endMoMDate) return 'Please select start and end month/year.';
            if (startMoMDate && endMoMDate && `${startMoMDate}` > `${endMoMDate}`) return 'End Month must be on/after Start Month.';
        } else if (statementType === YEAR_ON_YEAR_REPORT) {
            if (!propertyId) return 'Please select a property.';
            if (!startYearOnYearDate || !endYearOnYearDate) return 'Please select start and end years.';
            if (startYearOnYearDate && endYearOnYearDate && parseInt(startYearOnYearDate) > parseInt(endYearOnYearDate)) return 'End Year must be on/after Start Year.';
        }
        return null;
    }

    handleSubmitClick = (format) => {
        const error = this.validateInputs();
        if (error) {
            this.setState({ validationError: error });
            return;
        }
        this.setState({ validationError: '' });
        this.submit(format);
    }

    loadTenantOptionsForProperty = async (propertyId, statementType = this.state.statementType) => {
        if (!propertyId || ![TENANT_STATMENT, DELETED_TENANTS_REPORT].includes(statementType)){
            return;
        }
        try{
            this.setState({ loadingTenants: true });
            this.props.showLoading(true);
            const action = await this.props.fetchPropertyTenants({propertyIds:[propertyId]});
            const showArchivedOnly = statementType === DELETED_TENANTS_REPORT;
            const tenantOptions = Object.values(action.payload.tenants || {})
                .filter(t => showArchivedOnly ? t.archived : !t.archived)
                .map(t => {
                    const name = `${t.firstName || ''} ${t.lastName || ''}`.trim();
                    const unitName = t.unitName ? ` (${t.unitName})` : '';
                    const prefix = showArchivedOnly ? '[archived] ' : '';
                    return { id: t.tenantId, label: `${prefix}${name}${unitName}`.trim(), tenantDetails: t };
                });
            this.setState({ tenantOptions });
        } finally {
            this.setState({ loadingTenants: false });
            this.props.showLoading(false);
        }
    }

    handleReportChange = async (val) => {
        // When report type changes, clear previously shown results to avoid confusion
        const nextPropertyId = val === PROPERTY_STATEMENT
            ? (this.state.propertyIds.length === 1 ? this.state.propertyIds[0] : "")
            : this.state.propertyId;
        this.setState({
            statementType: val,
            tenant: [],
            tenantOptions: [],
            propertyIds: val === PROPERTY_STATEMENT ? this.state.propertyIds : this.state.propertyIds,
            propertyId: nextPropertyId,
            tableData: [],
            columns: [],
            propertyTables: null,
            multiPropertyData: null,
            filterErrors: [],
            collapseDate: true,
            collapseMoM: true,
            collapseYoY: true,
        });
        await this.loadTenantOptionsForProperty(nextPropertyId, val);
    }

    handleSelectAllProperties = (allPropertyIds) => {
        const isAllSelected = (this.state.propertyIds || []).length === allPropertyIds.length;
        const propertyIds = isAllSelected ? [] : allPropertyIds;
        const propertyId = propertyIds.length === 1 ? propertyIds[0] : "";
        this.setState((prev) => ({
            propertyIds,
            propertyId,
            filterErrors: (prev.filterErrors || []).filter((m) => m !== 'Property is required'),
        }));
    }

    handleSelectProperty = async (event) => {
        const value = event.detail.value;
        if (this.state.statementType === PROPERTY_STATEMENT){
            const propertyIds = Array.isArray(value) ? value : (value ? [value] : []);
            const propertyId = propertyIds.length === 1 ? propertyIds[0] : "";
            this.setState((prev) => ({
                propertyIds,
                propertyId,
                filterErrors: (prev.filterErrors || []).filter((m) => m !== 'Property is required'),
            }));
            return;
        }
        const propertyId = value;
        this.setState(prev => ({
            propertyId,
            tenant: [],
            tenantOptions: [],
            tableData: [],
            columns: [],
            propertyTables: null,
            multiPropertyData: null,
            filterErrors: (prev.filterErrors || []).filter(m => m !== 'Property is required')
        }));
        await this.loadTenantOptionsForProperty(propertyId, this.state.statementType);
    }

    handleTenantChange = (event) => {
        const selectedTenantIds = event.detail.value;
        let tenant = [];
        if (Array.isArray(selectedTenantIds)) {
            tenant = this.state.tenantOptions.filter((option) => selectedTenantIds.includes(option.id));
        } else {
            const option = this.state.tenantOptions.find(t => t.id === selectedTenantIds);
            tenant = option ? [option] : [];
        }
        this.setState(prev => ({ tenant, filterErrors: (prev.filterErrors || []).filter(m => m !== 'Tenant is required') }));
    }

    decodeActionDataToJson = (data) => new Promise((resolve, reject) => {
        try{
            if (data instanceof Blob) {
                const fr = new FileReader();
                fr.onload = (e) => {
                    try { resolve(JSON.parse(e.target.result)); }
                    catch (err) { reject(err); }
                };
                fr.onerror = reject;
                fr.readAsText(data);
            } else if (typeof data === 'string') {
                resolve(JSON.parse(data));
            } else {
                resolve(data);
            }
        }catch(err){
            reject(err);
        }
    })

    deriveColumns = (rows, selectedColumns = []) => {
        if (!Array.isArray(rows) || rows.length === 0) return [];
        const cols = Object.keys(rows[0]);
        if (Array.isArray(selectedColumns) && selectedColumns.length > 0) {
            return cols.filter((c) => selectedColumns.includes(c));
        }
        return cols;
    }

    

    validateFiltersForStep2 = () => {
        const errors = [];
        const {
            statementType,
            tenant,
            propertyId,
            startDate,
            endDate,
            startMoMDate,
            endMoMDate,
            startYearOnYearDate,
            endYearOnYearDate,
        } = this.state;

        if (statementType === TENANT_STATMENT) {
            if (!tenant?.[0]?.id) errors.push('Tenant is required');
        } else if (statementType === DELETED_TENANTS_REPORT) {
            if (!propertyId) errors.push('Property is required');
        } else if (statementType === PROPERTY_STATEMENT) {
            if (!this.state.propertyIds || this.state.propertyIds.length === 0) errors.push('Property is required');
            if (!startDate) errors.push('Start Date is required');
            if (!endDate) errors.push('End Date is required');
        } else if ([ARREARS_REPORT, EXPENSES_REPORT].includes(statementType)) {
            if (!propertyId) errors.push('Property is required');
            if (!startDate) errors.push('Start Date is required');
            if (!endDate) errors.push('End Date is required');
        } else if (statementType === MONTH_ON_MONTH_REPORT) {
            if (!propertyId) errors.push('Property is required');
            if (!startMoMDate) errors.push('Start Month is required');
            if (!endMoMDate) errors.push('End Month is required');
        } else if (statementType === YEAR_ON_YEAR_REPORT) {
            if (!propertyId) errors.push('Property is required');
            if (!startYearOnYearDate) errors.push('Start Year is required');
            if (!endYearOnYearDate) errors.push('End Year is required');
        }
        return errors;
    }

    handleNextFromFilters = () => {
        const errors = this.validateFiltersForStep2();
        if (errors.length > 0) {
            const expandDate = errors.some(m => m.includes('Date'));
            const expandMoM = errors.some(m => m.includes('Month'));
            const expandYoY = errors.some(m => m.includes('Year') && !m.includes('Month'));
            this.setState({
                filterErrors: errors,
                collapseDate: expandDate ? false : this.state.collapseDate,
                collapseMoM: expandMoM ? false : this.state.collapseMoM,
                collapseYoY: expandYoY ? false : this.state.collapseYoY,
            });
            return;
        }
        this.setState({ filterErrors: [], currentStep: 3 });
    }

    submit = async (outputFormat = 'json') => {
        const { statementType } = this.state;
        this.props.showLoading(true);
        try{
            if (statementType === TENANT_STATMENT){
                const tenantId = this.state.tenant?.[0]?.id;
                if (!tenantId) return;
                const action = await this.props.downloadTenantTransactionsReport({ tenantId, outputFormat });
                if (outputFormat === 'json'){
                    const json = await this.decodeActionDataToJson(action.data);
                        const rows = json["data"] || [];
                        const cols = rows.length > 0 ? Object.keys(rows[0]) : [];
                        this.setState({ tableData: rows, columns: cols });
                }
            } else if (statementType === PROPERTY_STATEMENT){
                const {
                    propertyIds,
                    startDate,
                    endDate,
                    selectedColumns,
                    showArchivedTenants,
                    showNonPropertyExpenses
                } = this.state;
                if (!propertyIds || propertyIds.length === 0 || !startDate || !endDate) return;
                const reportSettings = {
                    report_columns: selectedColumns,
                    show_archived_tenants: showArchivedTenants,
                    show_non_property_expenses: showNonPropertyExpenses,
                };
                if (propertyIds.length > 1) {
                    const payload = {
                        outputFormat,
                        startDate,
                        endDate,
                        propertyIds,
                        reportSettings,
                    };
                    const action = await this.props.generateMultiPropertyReports(payload);
                    if (outputFormat === 'json'){
                        const json = await this.decodeActionDataToJson(action.data);
                        const dataEnvelope = json?.data || json || {};
                        const properties = Array.isArray(dataEnvelope.properties) ? dataEnvelope.properties : [];
                        const propertyTables = properties.map((prop) => {
                            const tenants = Array.isArray(prop.tenants) ? prop.tenants : [];
                            const expenses = Array.isArray(prop.expenses) ? prop.expenses : [];
                            const summary = Array.isArray(prop.summary) ? prop.summary : [];
                            const occupancy = Array.isArray(prop.occupancy) ? prop.occupancy : [];
                            const summaryCols = this.deriveColumns(summary).filter(
                                (col) => String(col).toLowerCase() !== "total"
                            );
                            return {
                                propertyId: prop.propertyId,
                                propertyName: prop.propertyName,
                                tables: {
                                    tenants: { rows: tenants, cols: this.deriveColumns(tenants, selectedColumns) },
                                    expenses: { rows: expenses, cols: this.deriveColumns(expenses) },
                                    summary: { rows: summary, cols: summaryCols },
                                    occupancy: { rows: occupancy, cols: this.deriveColumns(occupancy) },
                                },
                            };
                        });
                        const overall = dataEnvelope.overall || {};
                        const overallExpenses = Array.isArray(overall.expenses) ? overall.expenses : [];
                        const hasOverallNonPropertyExpenses = Array.isArray(overall.nonPropertyExpenses);
                        const overallNonPropertyExpenses = hasOverallNonPropertyExpenses
                            ? overall.nonPropertyExpenses
                            : [];
                        const overallSummary = Array.isArray(overall.summary) ? overall.summary : [];
                        const overallOccupancy = Array.isArray(overall.occupancy) ? overall.occupancy : [];
                        const overallSummaryCols = this.deriveColumns(overallSummary).filter(
                            (col) => String(col).toLowerCase() !== "total"
                        );
                        const overallTables = {
                            expenses: { rows: overallExpenses, cols: this.deriveColumns(overallExpenses) },
                            summary: { rows: overallSummary, cols: overallSummaryCols },
                            occupancy: { rows: overallOccupancy, cols: this.deriveColumns(overallOccupancy) },
                        };
                        if (hasOverallNonPropertyExpenses) {
                            overallTables.nonPropertyExpenses = {
                                rows: overallNonPropertyExpenses,
                                cols: this.deriveColumns(overallNonPropertyExpenses),
                            };
                        }
                        this.setState({
                            multiPropertyData: { properties: propertyTables, overall: overallTables },
                            tableData: [],
                            columns: [],
                            propertyTables: null,
                        });
                    }
                } else {
                    const propertyId = propertyIds[0];
                    const payload = { outputFormat, startDate, endDate, propertyId, reportSettings };
                    const action = await this.props.generateReports(payload);
                    if (outputFormat === 'json'){
                        const json = await this.decodeActionDataToJson(action.data);
                        // Property Statement payload groups arrays under `data`
                        const dataEnvelope = (json && typeof json === 'object' && Array.isArray(json)) ? { tenants: json } : (json?.data || json || {});
                        const tenants = Array.isArray(dataEnvelope.tenants) ? dataEnvelope.tenants : [];
                        const expenses = Array.isArray(dataEnvelope.expenses) ? dataEnvelope.expenses : [];
                        const summary = Array.isArray(dataEnvelope.summary) ? dataEnvelope.summary : [];
                        const occupancy = Array.isArray(dataEnvelope.occupancy) ? dataEnvelope.occupancy : [];
                        const hasNonPropertyExpenses = Array.isArray(dataEnvelope.nonPropertyExpenses);
                        const nonPropertyExpenses = hasNonPropertyExpenses
                            ? dataEnvelope.nonPropertyExpenses
                            : [];

                        const summaryCols = this.deriveColumns(summary).filter(
                            (col) => String(col).toLowerCase() !== "total"
                        );
                        const propertyTables = {
                            tenants: { rows: tenants, cols: this.deriveColumns(tenants, selectedColumns) },
                            expenses: { rows: expenses, cols: this.deriveColumns(expenses) },
                            summary: { rows: summary, cols: summaryCols },
                            occupancy: { rows: occupancy, cols: this.deriveColumns(occupancy) },
                        };
                        if (hasNonPropertyExpenses) {
                            propertyTables.nonPropertyExpenses = {
                                rows: nonPropertyExpenses,
                                cols: this.deriveColumns(nonPropertyExpenses),
                            };
                        }

                        // default single-table fallback to tenants
                        const rows = propertyTables.tenants.rows;
                        const cols = propertyTables.tenants.cols;
                        this.setState({ propertyTables, tableData: rows, columns: cols, multiPropertyData: null });
                    }
                }
            } else if (statementType === ARREARS_REPORT){
                const { startDate, endDate, propertyId } = this.state;
                const propertyIds = propertyId ? [propertyId] : [];
                const action = await this.props.generateArrearsReports({ outputFormat, startDate, endDate, propertyIds, reportSettings: {} });
                if (outputFormat === 'json'){
                    const json = await this.decodeActionDataToJson(action.data);
                    const dataEnvelope = json?.data || json || {};
                    const tenants = Array.isArray(dataEnvelope.tenants) ? dataEnvelope.tenants : (Array.isArray(dataEnvelope.rows) ? dataEnvelope.rows : []);
                    const cols = tenants.length > 0 ? Object.keys(tenants[0]) : [];
                    this.setState({ tableData: tenants, columns: cols });
                }
            } else if (statementType === EXPENSES_REPORT){
                const { startDate, endDate, propertyId } = this.state;
                const action = await this.props.generateExpensesReports({ outputFormat, startDate, endDate, propertyId });
                if (outputFormat === 'json'){
                    const json = await this.decodeActionDataToJson(action.data);
                    const dataEnvelope = json?.data || json || {};
                    const rows = Array.isArray(dataEnvelope.expenses) ? dataEnvelope.expenses : (Array.isArray(dataEnvelope.rows) ? dataEnvelope.rows : []);
                        const cols = rows.length > 0 ? Object.keys(rows[0]) : [];
                        this.setState({ tableData: rows, columns: cols });
                }
            } else if (statementType === MONTH_ON_MONTH_REPORT){
                const { propertyId, startMoMDate, endMoMDate } = this.state;
                if (!propertyId || !startMoMDate || !endMoMDate) return;
                const payload = { outputFormat, startDate: startMoMDate, endDate: endMoMDate, propertyId };
                const action = await this.props.generateMonthOnMonthReports(payload);
                if (outputFormat === 'json'){
                    const json = await this.decodeActionDataToJson(action.data);
                    const dataEnvelope = json?.data || json || {};
                    const rows = Array.isArray(dataEnvelope.report_data) ? dataEnvelope.report_data : (Array.isArray(dataEnvelope.rows) ? dataEnvelope.rows : []);
                        const cols = rows.length > 0 ? Object.keys(rows[0]) : [];
                        this.setState({ tableData: rows, columns: cols });
                }
            } else if (statementType === YEAR_ON_YEAR_REPORT){
                const { propertyId, startYearOnYearDate, endYearOnYearDate } = this.state;
                if (!propertyId || !startYearOnYearDate || !endYearOnYearDate) return;
                const payload = { outputFormat, startDate: startYearOnYearDate, endDate: endYearOnYearDate, propertyId };
                const action = await this.props.generateYearOnYearReports(payload);
                if (outputFormat === 'json'){
                    const json = await this.decodeActionDataToJson(action.data);
                    const dataEnvelope = json?.data || json || {};
                    const rows = Array.isArray(dataEnvelope.report_data) ? dataEnvelope.report_data : (Array.isArray(dataEnvelope.rows) ? dataEnvelope.rows : []);
                    const cols = rows.length > 0 ? Object.keys(rows[0]) : [];
                    this.setState({ tableData: rows, columns: cols });
                }
            } else if (statementType === PROPERTY_GROUPING_REPORT){
                const { groupingIds, startDate, endDate, selectedGroupingGraphColumns } = this.state;
                const payload = { outputFormat, groupingIds, startDate, endDate, chartGraph: selectedGroupingGraphColumns };
                const action = await this.props.generatePropertyGroupingReport(payload);
                if (outputFormat === 'json'){
                    const json = await this.decodeActionDataToJson(action.data);
                        const rows = json["data"] || [];
                        const cols = rows.length > 0 ? Object.keys(rows[0]) : [];
                        this.setState({ tableData: rows, columns: cols });
                }
            } else if (statementType === DELETED_TENANTS_REPORT){
                const { propertyId, tenant } = this.state;
                if (!propertyId) return;
                const tenantIds = (tenant || []).map(({ id }) => id);
                const action = await this.props.generateDeletedTenantsReport({ outputFormat, propertyId, tenantIds });
                if (outputFormat === 'json'){
                    const json = await this.decodeActionDataToJson(action.data);
                    const rows = json["data"] || [];
                    const cols = rows.length > 0 ? Object.keys(rows[0]) : [];
                    this.setState({ tableData: rows, columns: cols });
                }
            }
        } catch (error) {
            console.error('Report submission failed:', error);
            this.setState({ validationError: 'Failed to load report. Please check inputs and try again.' });
        } finally{
            this.props.showLoading(false);
        }
    }

    render(){
        const { options } = this.props;
        const invalidMessage = this.validateInputs();
        const canSubmit = invalidMessage === null;
        const resolvedPropertyId = this.state.propertyId
            || (this.state.propertyIds.length === 1 ? this.state.propertyIds[0] : "");
        const propertyName = resolvedPropertyId
            ? (this.props.properties?.[resolvedPropertyId]?.propertyName || '')
            : '';
        const allPropertyIds = Object.values(this.props.properties || {}).map((p) => p.propertyId);
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>Reports</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonGrid>
                        {this.state.currentStep === 1 && (
                        <IonRow>
                            <IonCol size="12">
                                <Card className="full-width-card">
                                    <Title>Step 1: Select Statement</Title>
                                    <IonRow>
                                        <IonCol size="12"><hr className="reports-divider" /></IonCol>
                                    </IonRow>
                                    <div>
                                        <SelectReportType
                                            statementType={this.state.statementType}
                                            statementTypes={STATEMENT_TYPES}
                                            options={options}
                                            onChangeStatement={this.handleReportChange}
                                        />
                                    </div>
                                </Card>
                            </IonCol>
                        </IonRow>
                        )}

                        {this.state.currentStep === 2 && (
                                                        <IonRow>
                                                            <IonCol size="12">
                                <SelectReportFilters
                                    options={options}
                                    properties={this.props.properties}
                                    statementType={this.state.statementType}
                                    propertyId={this.state.propertyId}
                                    propertyIds={this.state.propertyIds}
                                    tenant={this.state.tenant}
                                    tenantOptions={this.state.tenantOptions}
                                    loadingTenants={this.state.loadingTenants}
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    startMoMDate={this.state.startMoMDate}
                                    endMoMDate={this.state.endMoMDate}
                                    startYearOnYearDate={this.state.startYearOnYearDate}
                                    endYearOnYearDate={this.state.endYearOnYearDate}
                                    selectedColumns={this.state.selectedColumns}
                                    showArchivedTenants={this.state.showArchivedTenants}
                                    showNonPropertyExpenses={this.state.showNonPropertyExpenses}
                                    columnsModalOpen={this.state.columnsModalOpen}
                                    tmpSelectedColumns={this.state.tmpSelectedColumns}
                                    filterErrors={this.state.filterErrors}
                                    collapseDate={this.state.collapseDate}
                                    collapseMoM={this.state.collapseMoM}
                                    collapseYoY={this.state.collapseYoY}
                                    onSelectProperty={this.handleSelectProperty}
                                    onTenantChange={this.handleTenantChange}
                                    setColumnsModalOpen={(v) => this.setState({ columnsModalOpen: v, tmpSelectedColumns: v ? [...(this.state.selectedColumns || [])] : this.state.tmpSelectedColumns })}
                                    setTmpSelectedColumns={(v) => this.setState({ tmpSelectedColumns: v })}
                                    setSelectedColumns={(v) => this.setState({ selectedColumns: v, columnsModalOpen: false })}
                                    setShowArchivedTenants={(v) => this.setState({ showArchivedTenants: v })}
                                    setShowNonPropertyExpenses={(v) => this.setState({ showNonPropertyExpenses: v })}
                                    allPropertyIds={allPropertyIds}
                                    onSelectAllProperties={() => this.handleSelectAllProperties(allPropertyIds)}
                                    setCollapseDate={(v) => this.setState({ collapseDate: v })}
                                    setCollapseMoM={(v) => this.setState({ collapseMoM: v })}
                                    setCollapseYoY={(v) => this.setState({ collapseYoY: v })}
                                    setStartDate={(v) => this.setState(prev => ({ startDate: v, filterErrors: (prev.filterErrors || []).filter(m => m !== 'Start Date is required') }))}
                                    setEndDate={(v) => this.setState(prev => ({ endDate: v, filterErrors: (prev.filterErrors || []).filter(m => m !== 'End Date is required') }))}
                                    setStartMoMDate={(v) => this.setState(prev => ({ startMoMDate: v, filterErrors: (prev.filterErrors || []).filter(m => m !== 'Start Month is required') }))}
                                    setEndMoMDate={(v) => this.setState(prev => ({ endMoMDate: v, filterErrors: (prev.filterErrors || []).filter(m => m !== 'End Month is required') }))}
                                    setStartYoYDate={(v) => this.setState(prev => ({ startYearOnYearDate: v, filterErrors: (prev.filterErrors || []).filter(m => m !== 'Start Year is required') }))}
                                    setEndYoYDate={(v) => this.setState(prev => ({ endYearOnYearDate: v, filterErrors: (prev.filterErrors || []).filter(m => m !== 'End Year is required') }))}
                                />
                                                        </IonCol>
                                                    </IonRow>
                                                )}

                        {this.state.currentStep === 3 && (
                                                    <IonRow>
                                                        <IonCol size="12">
                                <GenerateReportData
                                    canSubmit={canSubmit}
                                    invalidMessage={invalidMessage}
                                    validationError={this.state.validationError}
                                    onView={() => this.handleSubmitClick('json')}
                                    onDownloadPdf={() => this.handleSubmitClick('pdf')}
                                    onDownloadExcel={() => this.handleSubmitClick('excel')}
                                    statementType={this.state.statementType}
                                    propertyId={this.state.propertyId}
                                    propertyIds={this.state.propertyIds}
                                    propertyName={propertyName}
                                    propertyTables={this.state.propertyTables}
                                    multiPropertyData={this.state.multiPropertyData}
                                    tableData={this.state.tableData}
                                    columns={this.state.columns}
                                />
                            </IonCol>
                        </IonRow>
                        )}
                    </IonGrid>
                </IonContent>
                <WizardFooter
                    currentStep={this.state.currentStep}
                    onBack={() => this.setState({ currentStep: this.state.currentStep === 3 ? 2 : 1 })}
                    onNext={() => (this.state.currentStep === 1 ? this.setState({ currentStep: 2 }) : this.handleNextFromFilters())}
                />
            </IonPage>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports));


